import { combineReducers } from 'redux'
import {undoHistoryReducer} from 'redux-undo-redo'
import project from './project'
import library from './library'
import localStore from './localStore'

const AnimakerStore = combineReducers({
  project,
  library,
  localStore,
  undoHistory: undoHistoryReducer
})

export default AnimakerStore


// WEBPACK FOOTER //
// ./src/reducers/index.js